export default __webpack_public_path__ + "static/media/chevron-left.92d8171a.svg";